import JobTriggerPanel from "components/Socials/JobTriggerPanel"
import Typography from "components/Typography"

import { ComponentProps } from "."
import { Wrapper } from "./styled"

const JobTriggers = (props: ComponentProps) => (
  <Wrapper>
    <Typography.H1>{"Job Triggers"}</Typography.H1>

    <JobTriggerPanel {...props} />
  </Wrapper>
)

export default JobTriggers
